<template>
    <header id="header">
      <div class="inner_static">
        <h1 id="h_logo" class="kagull_logo_h1">
          <strong>カグル.</strong>
        </h1>
        <ul id="gnb">
          <li>
            <a class="user_info">
              <span class="thumb"></span>
              <strong class="name">{{this.userName}}</strong>
            </a>
          </li>
          <li>
            <a id="btn_grid" @click="btnGridClick()"></a>
          </li>
          <li>
            <a id="btn_menu" @click="btnMenuClick()">
              <span></span>
            </a>
          </li>
        </ul>
        <kg-menu
          @menuCloseEvent="menuClose()"
          @toSearchEvent="toSearch()"/>
      </div>
    </header>
</template>

<script>
import {KG_STORAGE_KEY} from '../../../constants/App'
import * as App from '../../../utils/App'

// kaggul Module
import KgMenu from '../../components/common/KgMenu'

export default {
  components: {
    'kg-menu': KgMenu
  },
  data () {
    return {
      userName: ''
    }
  },
  methods: {
    btnMenuClick: function (event) {
      // メニューを表示する
      if (event) {
        event.preventDefault()
      }
      let scrollpos = 0
      let target = document.getElementById('pnavWrap')
      let bodyElements = document.getElementsByTagName('body')
      if (target.classList.contains('open')) {
        target.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        target.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    btnGridClick: function () {
      this.$router.push('/kagull/planning/category')
    },
    menuClose: function () {
      this.btnMenuClick(null)
    },
    toSearch: function () {
      this.$emit('openSearchBoxEvent')
    }
  },
  mounted: function () {
    if (App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)) {
      this.userName = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO).userNickName
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/common/Header.vue